var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-col',[_c('section-divider',{attrs:{"icon":"el-icon-s-tools","text":_vm.$t('section_title')}}),_c('settings-block',{staticStyle:{"margin":"0 20px"},attrs:{"script":_vm.script,"custom-fields":_vm.customFields,"show-embedded-code":""},on:{"onSave":function (v) { return v
          .save()
          .then(function () { return _vm.$notify({ type: 'success', message: this$1.$t('saved_settings') }); }
          )
          .catch(function () {}); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }